<template>
	<div id="app" class="pageContent">
		<k-loading />
		<k-black-screen />
		<router-view></router-view>
		<update-version-modal ref="updateVersionModal" />
	</div>
</template>

<script>
import KLoading from "./components/ui/KLoading.vue";
import KBlackScreen from "./components/ui/KBlackScreen.vue";
import ModalMixin from "@/mixins/ModalMixin";
import UpdateVersionModal from "./components/modals/UpdateVersionModal.vue";
import { mapGetters } from "vuex";

export default {
	name: "App",
	components: { KLoading, KBlackScreen, UpdateVersionModal },
	mixins: [ModalMixin],
	computed: {
		...mapGetters(["actualUser"])
	},
	mounted() {
		if (!this.$route.meta?.isIframe) {
			window.addEventListener("storage", this.handleStorageOnChange, false);
		}
	},
	beforeDestroy() {
		window.removeEventListener("storage", this.handleStorageOnChange, false);
	},
	methods: {
		handleStorageOnChange(event) {
			if (this.$route.meta?.isIframe) {
				return;
			}

			if (
				event.key === "version" &&
				event.oldValue !== event.newValue &&
				this.$router.currentRoute.name !== "Login" &&
				this.$router.currentRoute.name !== "inviteOffer" &&
				this.$router.currentRoute.name !== "LoginSupplier"
			) {
				this.$bvModal.show("updateVersionModal");
			} else {
				window.location.reload();
			}
		}
	},
	watch: {
		$route({ name }) {
			if (name == "clientList" && !this.actualUser.isAdmin) {
				this.$router.push({
					name: "Unauthorized"
				});
			}
		}
	}
};
</script>

<style lang="scss">
@import "./assets/css/klassmatt.css";
@import "./assets/css/_custom.scss";
@import "./components/ui/Toast/customToast.scss";
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/icons.scss";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<style scoped>
.pageContent {
	height: 100%;
}
</style>
